import { takeLatest } from 'redux-saga/effects';
import {
  getEmployeeLeaveCreditListSuccess, getEmployeeLeaveCreditListFail,
  getEmployeeLeaveCreditDetailsSuccess, getEmployeeLeaveCreditDetailsFail
} from './employeeLeaveCreditState';
import createCrudService from '../../services/crudservice';
import { 
  doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
  createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/timekeeping/employee-leave-credits');
const redirectData = { route:'/console/employee-leave-credits', mode:'list', recordId:0 };
const modelName = 'EmployeeLeaveCredit';
const modelId = 'elc_id';

function* getEmployeeLeaveCreditList(data) {
  yield doCrudCall(
    () => crudService.getList(data.payload),
    getEmployeeLeaveCreditListSuccess,
    getEmployeeLeaveCreditListFail,
    null,
    null,
    LOADING_MSG
  );
}

function* getEmployeeLeaveCreditDetails(data) {
  yield doCrudCall(
    () => crudService.getDetails(data.payload),
    getEmployeeLeaveCreditDetailsSuccess,
    getEmployeeLeaveCreditDetailsFail,
    null,
    null,
    LOADING_MSG
  );
}

function* doEmployeeLeaveCreditCreate(data) {
  yield doCrudCall(
    () => crudService.doCreate(data.payload),
    getEmployeeLeaveCreditDetailsSuccess,
    getEmployeeLeaveCreditDetailsFail,
    createRecordSuccess(modelName),
    { ...redirectData, mode:'reload' },
    SAVING_MSG
  );
}

function* doEmployeeLeaveCreditUpdate(data) {
  yield doCrudCall(
    () => crudService.doUpdate(data.payload[modelId], data.payload),
    getEmployeeLeaveCreditDetailsSuccess,
    getEmployeeLeaveCreditDetailsFail,
    updateRecordSuccess(modelName),
    { ...redirectData, mode:'reload' },
    UPDATING_MSG
  );
}

function* doEmployeeLeaveCreditDelete(data) {
  yield doCrudCall(
    () => crudService.doDelete(data.payload.recordId),
    getEmployeeLeaveCreditDetailsSuccess,
    getEmployeeLeaveCreditDetailsFail,
    deleteRecordSuccess(modelName),
    { ...redirectData, mode:data.payload.mode },
    DELETING_MSG
  );
}

function* employeeLeaveCreditSaga() {
  yield takeLatest('employeeLeaveCredit/getEmployeeLeaveCreditList', getEmployeeLeaveCreditList);
  yield takeLatest('employeeLeaveCredit/getEmployeeLeaveCreditDetails', getEmployeeLeaveCreditDetails);
  yield takeLatest('employeeLeaveCredit/doEmployeeLeaveCreditCreate', doEmployeeLeaveCreditCreate);
  yield takeLatest('employeeLeaveCredit/doEmployeeLeaveCreditUpdate', doEmployeeLeaveCreditUpdate);
  yield takeLatest('employeeLeaveCredit/doEmployeeLeaveCreditDelete', doEmployeeLeaveCreditDelete);
}

export default employeeLeaveCreditSaga;
